import Cookies from 'js-cookie';
import { getBuyerId } from 'dibs-cookie-jar';
import { localStorage } from 'dibs-browser-storage';
import guidGenerator from '../components/global/guidGenerator';
import { PAGEVIEW_LIMIT_FLOW, sharedLoginCheck } from '../authentication/sharedLoginCheck';
import { LABEL_PAGEVIEW_LIMIT } from '../authentication/authConstants';
import * as constants from '../constants/userConstants';

Cookies.defaults = constants.defaultCookieSettings;

export function setGuestId() {
    Cookies.set(constants.GUEST_ID, guidGenerator());
}

/**
 * TODO: Should be
 * function logoutFunc() {
     if (isMasqueradingAsBuyer(document.cookie)) {
         Cookies.remove(MASQUERADE_BUYER);
     } else {
         Cookies.remove(USER);
         Cookies.remove(USER_EMAIL);
         Cookies.remove(USER_TYPE);
     }
     location.reload();

     Best to get from DBL?
 }
 */
export function logout() {
    Cookies.remove(constants.USER_TOKEN);
    Cookies.remove(constants.USER_TYPE);
    location.reload();
}

// if 'session' from pseudoSession has reached the regPromptLimit, then
// display the auth modal. if user has logged in show login; otherwise, show registration.
// TODO: Remove once set up to use DBL notification queue
export function showAuthModal() {
    return () => {
        const userId = getBuyerId(document.cookie);
        const visitCount = localStorage.getItem(constants.VISIT_COUNT) || {};
        const pseudoSession = localStorage.getItem(constants.PSEUDO_SESSION) || {};

        const { regPromptLimit = constants.REG_PROMPT_LIMIT } = visitCount;
        const { session = 0 } = pseudoSession;

        if (session === regPromptLimit && !userId) {
            sharedLoginCheck({
                authOptions: {
                    flow: PAGEVIEW_LIMIT_FLOW,
                    ga: { label: LABEL_PAGEVIEW_LIMIT },
                },
            });
        }
    };
}
